import React from 'react';

import styles from './style.scss';


const EmptyCatalogDescription = () => (
  <React.Fragment>
    <div className={styles.tagsEmpty} />
    <div className={styles.descriptionEmpty} />
    <div className={styles.descriptionEmpty} />
    <div className={styles.descriptionEmpty} />
    <div className={styles.descriptionEmpty} />
    <div className={styles.descriptionEmpty} />
  </React.Fragment>
);

export default EmptyCatalogDescription;
